module.exports = __webpack_public_path__ + "static/media/TaskFeature3.62b2164a.avif";